import React, { useState } from 'react';
import { Button, Card, CardContent, CardHeader, Badge, Typography, Box, Switch } from '@mui/material';
import { Check, Star, ArrowRight, CreditCard } from '@mui/icons-material';
import RegPayment from '../components/RegPayment';

const plans = [

  {
    id: 'pro',
    name: 'Conquer',
    icon: <Star />,
    description: 'For active traders',
    monthlyPrice: 999.99,
    yearlyPrice: 9999.99,
    duration:"Daily",
    features: [
      'Access to all 12 business models',
      'VIP account ranking',
      '7 connected devices',
      'Step-by-step learning & priority support',
      'Daily course updates & live broadcasts',
    ],
    notIncluded: [],
    popular: true,
    buttonText: 'Join Now',
    buttonVariant: 'contained',
  },
  {
    id: 'premium',
    name: 'Vanguard',
    icon: <CreditCard />,
    description: 'For professional traders',
    monthlyPrice: 1999.99,
    yearlyPrice: 19999.99,
    duration:"Weekly",
    features: [
      'Everything in Conquer',
      'Early access to features',
    ],
    notIncluded: [],
    popular: false,
    buttonText: 'Join Now',
    buttonVariant: 'contained',
  },
  {
    id: 'boss',
    name: 'Conquest',
    icon: <CreditCard />,
    description: 'For masters',
    monthlyPrice: 2999.99,
    yearlyPrice: 29999.99,
    duration:"Monthly",
    features: [
      'Everything in Vanguard',
      'Experimental Feature Access',
    ],
    notIncluded: [],
    popular: false,
    buttonText: 'Join Now',
    buttonVariant: 'contained',
  },
];

const SignUp = () => {
  const [isYearly, setIsYearly] = useState(false);
  const [currentPlan, ] = useState('basic');
  const [paymentMethod, setPaymentMethod] = useState(false);
  const [amount, setAmount] = useState(0)

  const handleUpgrade = (amount) => {
    setAmount(amount)
    setPaymentMethod(true)
  };
  

  return (
    <div className="grid justify-center items-center">
      {paymentMethod ? (
        <RegPayment data={amount} />
      ) : (
        <Box sx={{ minHeight: '100vh', padding: 2 }}>
          {/* Header Section */}
          <Box sx={{ textAlign: 'center', marginBottom: 8 }}>
            <Typography variant="h4" component="h1" gutterBottom color={"white"}>
              Choose Your Trading Plan
            </Typography>
            <Typography variant="body1" color="white" sx={{ maxWidth: 600, margin: '0 auto' }}>
              Unlock powerful trading features and maximize your potential with our flexible subscription plans.
            </Typography>

            {/* Billing Toggle */}
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 4, marginTop: 4 }}>
              <Typography variant="body1" color={!isYearly ? 'white' : 'white'}>
                Monthly
              </Typography>
              <Switch checked={isYearly} onChange={() => setIsYearly(!isYearly)} />
              <Typography variant="body1" color={isYearly ? 'white' : 'white'}>
                Yearly
              </Typography>
              {isYearly && <Badge color="success" badgeContent="Save 17%" />}
            </Box>
          </Box>

          {/* Pricing Plans */}
          <Box sx={{ marginBottom: 8 }}>
            <div className='grid md:grid-cols-3 grid-cols-1 gap-4'>
              {plans.map((plan) => (
                <Card key={plan.id} sx={{ width: '100%', boxShadow: 3, '&:hover': { boxShadow: 6 } }}>
                  <CardHeader
                    sx={{
                      textAlign: 'center',
                      backgroundColor: plan.popular ? '#3B9797' : '#3B9797',
                      color: 'white',
                      
                    }}
                    className='!text-white'
                    title={plan.name}
                    // subheader={plan.description}
                  />
                  <CardContent>
                    <Typography variant="h5">
                      €{isYearly ? plan.yearlyPrice : plan.monthlyPrice}/{isYearly ? 'year' : plan.duration}
                    </Typography>
                    <Button
                      variant={plan.buttonVariant}
                      className='!bg-[#16476A]'
                      sx={{ width: '100%', marginTop: 2 }}
                      disabled={currentPlan === plan.id}
                      onClick={() => handleUpgrade(isYearly ? plan.yearlyPrice : plan.monthlyPrice)}
                    >
                      {currentPlan === plan.id ? 'Current Plan' : plan.buttonText}
                      {currentPlan !== plan.id && <ArrowRight sx={{ marginLeft: 1 }} />}
                    </Button>

                    {/* Features */}
                    <Box sx={{ marginTop: 2 }}>
                      {plan.features.map((feature, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Check color="success" />
                          <Typography variant="body2">{feature}</Typography>
                        </Box>
                      ))}
                      {plan.notIncluded.map((feature, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 2, opacity: 0.5 }}>
                          <Typography variant="body2" sx={{ textDecoration: 'line-through' }}>
                            {feature}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </div>

          </Box>
        </Box>
      )}
    </div>

  );
};

export default SignUp;
